var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3018 114.63C45.5068 114.63 20.5426 89.6656 20.5426 58.8706C20.5426 28.0756 45.5068 3.11133 76.3018 3.11133C107.097 3.11133 132.061 28.0756 132.061 58.8706C132.061 89.6656 107.097 114.63 76.3018 114.63Z",
    fill: "#FBFBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2347 126.791L99.3775 117.885C101.236 117.649 102.551 115.951 102.315 114.093L90.9 24.1949C90.664 22.3366 88.9661 21.0213 87.1078 21.2574L16.9649 30.1641C15.1066 30.4 13.7913 32.0978 14.0274 33.9563L25.4426 123.854C25.6785 125.712 27.3764 127.028 29.2347 126.791Z",
    fill: "#68E5BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.794 36.1646H98.4477C99.3532 36.1646 100.141 36.8752 100.207 37.7516L107.064 128.863C107.13 129.74 106.45 130.45 105.544 130.45H31.3334C30.4279 130.45 29.6404 129.74 29.5744 128.863L23.6318 49.9068L36.794 36.1646Z",
    fill: "#7C7C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.139 47.6626V129.229C30.139 129.604 30.2654 129.951 30.4777 130.227V130.228C30.7781 130.618 31.2489 130.869 31.7791 130.869H105.989C106.895 130.869 107.629 130.135 107.629 129.229V35.1057C107.629 34.1999 106.895 33.4658 105.989 33.4658H44.3359L30.139 47.6626Z",
    fill: "#ECECEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.401 47.6625H30.1389L44.3354 33.4658V45.728C44.3354 46.7965 43.4694 47.6625 42.401 47.6625Z",
    fill: "#C7C7C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.5557,
    y: 70,
    width: 35.7778,
    height: 4.66667,
    rx: 1.55556,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5557,
    y: 80.8889,
    width: 35.7778,
    height: 4.66667,
    rx: 1.55556,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5557,
    y: 91.7778,
    width: 35.7778,
    height: 4.66667,
    rx: 1.55556,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5557,
    y: 102.667,
    width: 35.7778,
    height: 4.66667,
    rx: 1.55556,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4131,
    y: 82.3745,
    width: 4.68557,
    height: 1.64933,
    rx: 0.824666,
    transform: "rotate(51.6783 47.4131 82.3745)",
    fill: "#6CD0AE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.06084,
    height: 1.64933,
    rx: 0.824666,
    transform: "matrix(-0.571198 0.820813 0.820813 0.571198 52.8267 79.3335)",
    fill: "#6CD0AE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4131,
    y: 93.2632,
    width: 4.68557,
    height: 1.64933,
    rx: 0.824666,
    transform: "rotate(51.6783 47.4131 93.2632)",
    fill: "#6CD0AE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8.06084,
    height: 1.64933,
    rx: 0.824666,
    transform: "matrix(-0.571198 0.820813 0.820813 0.571198 52.8267 90.2217)",
    fill: "#6CD0AE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4131,
    y: 71.4861,
    width: 4.68557,
    height: 1.64933,
    rx: 0.824666,
    transform: "rotate(51.6783 47.4131 71.4861)",
    fill: "#6CD0AE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.06084,
    height: 1.64933,
    rx: 0.824666,
    transform: "matrix(-0.571198 0.820813 0.820813 0.571198 52.8267 68.4451)",
    fill: "#6CD0AE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4131,
    y: 104.152,
    width: 4.68557,
    height: 1.64933,
    rx: 0.824666,
    transform: "rotate(51.6783 47.4131 104.152)",
    fill: "#6CD0AE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8.06084,
    height: 1.64933,
    rx: 0.824666,
    transform: "matrix(-0.571198 0.820813 0.820813 0.571198 52.8267 101.111)",
    fill: "#6CD0AE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIllustration);
export default __webpack_public_path__ + "static/media/document-illustration.1708329c654b84bbc9b71b6f1e1b5f03.svg";
export { ForwardRef as ReactComponent };